
export const PATH_NAME = {
    ROOT: '/',
    ABOUT_US: '/about',
    SMART_FRIDGE: '/smart_fridge',
    DELETE_ACCOUNT: '/delete_account',
    ERROR_404: '/404',
    ERROR_403: '/403',
    MEMBER: '/member',
    LOGIN: '/login',
    REGISTER: '/register',
    VERIFY_OTP: '/verify-otp',
    TOPUP: '/member/topup',
    PROFILE: '/member/profile',
    MENU: '/menu/:machine_id',
    LOCATIONS: '/locations',
    COLLECTIONS: '/collections/:slug',
    ALLPRODUCTS: '/all_products',
    EDIT_PROFILE: '/member/edit_profile',
    CARD_DETAILS: '/member/card_details/',
    ORDER_DETAILS: '/member/order_details/',
    INTRODUCTION: '/member/introduction',
    PAYMENT_SUCCESS: '/member/payment_success',
    FORGET_PASSWORD: '/forget-password',
    RESET_PASSWORD_VERIFY: '/reset-password-verify',
    PRODUCT: '/product/:slug?',
    PRODUCTS: '/products/:slug',
    CHECKOUT: '/checkout',
    CART:'cart',
    PRIVACY_POLICY: '/privacy_policy',
    GUEST_PAYMENT:'/guest_payment',
    TEST_GOOGLE_PAY_URL: '/test-google-pay-url',

    // Authentication
    API_AUTH_LOGIN: '/api/auth/login',
    API_AUTH_SIGN_UP: '/api/auth/sign_up',
    API_AUTH_SEND_OTP: '/api/auth/send_otp',
    API_AUTH_SEND_OTP_FOR_SIGNUP: '/api/auth/send_otp_for_signup',
    API_AUTH_RESET_PASSWORD: '/api/auth/new_reset_password',
    API_AUTH_PROFILE: '/api/auth/profile',
    API_AUTH_CHECK_MOBILE_EXIST: '/api/auth/is_mobile_available',
    API_AUTH_DELETE_ACCOUNT: '/api/auth/delete-account',

    // Users
    API_QR_CODE: '/api/users/qr_code',
    API_GET_USER_VOUCHERS: '/api/users/get_my_coupons',
    API_MACHINE_LOGIN: '/api/users/machine_login',
    API_SYNC_USER_TO_SHOPIFY: '/api/users/sync_user_to_shopify',
    API_UPDATE_USER_INFO: '/api/users/update_user_info',
    API_USER_GET_REWARD_POINTS: '/api/users/get_reward_points',
    API_USER_GET_REWARD_POINTS_BALANCE: '/api/users/get_reward_point_balance',

    // StoreCredits
    API_STORE_CREDITS_BALANCE: '/api/store_credits/balance',
    API_STORE_CREDITS_WALLET: '/api/store_credits/wallet',
    API_STORE_CREDITS_TRANSACTIONS: '/api/store_credits/transactions',

    // Payment
    API_PAYMENT_REQUEST_TOKEN: '/api/payment/request_payment_token',
    API_PAYMENT_PAYNOW: '/api/payment/paynow/',
    API_PAYMENT_SETTLEMENT: '/api/payment/request_direct_payment_topup',

    // PaymentMethod
    API_GET_MY_PAYMENT_METHODS: '/api/payment_method/get_my_payment_methods',
    API_DELETE_PAYMENT_METHOD: '/api/payment_method',

    // Orders
    API_GET_ORDER_ID: (order_id: string) => `/api/orders/${order_id}`,
    API_GET_ORDER_BY_USER_ID: '/api/orders/get_my_orders',
    API_CREATE_ORDER:'/api/orders/',
    
    // Transactions
    API_TRANSACTION_START: '/api/transactions/start',
    API_GET_TRANSACTION_PAYMENT: (transaction_id: number) => `/api/transactions/get_transaction_payment/${transaction_id}`,

    //Guest Transactions
    API_GUEST_TRANSACTION_START: '/api/guest_transactions/start',

    // Collections
    API_GET_COLLECTION: '/api/collections/',
    API_GET_COLLECTION_BY_ID: (id: string) => `/api/collections/${id}`,
    API_GET_COLLECTION_BY_SLUG: (slug: string) => `/api/collections/by-slug/${slug}`,

    // Skus
    API_GET_SKU_DETAILS: '/api/sku-details/',
    API_GET_SKU_DETAILS_BY_SKU: (sku: string) => `/api/sku-details/${sku}`,
    API_GET_SKU_DETAILS_BY_SLUG: (slug: string) => `/api/sku-details/by-slug/${slug}`,


    // Cart
    API_GET_CART_ITEMS: '/api/carts/',
    API_UPDATE_CART_ITEM: '/api/carts/',

    // Product
    PRODUCT_DETAILS: (slug: string) => `/product/${slug}`,

    // Banner
    API_ACTIVE_BANNERS: '/api/banners/',

    // Assets
    API_ASSETS: '/api/assets/',

    // ContactForm
    API_CONTACT_FORM: '/api/contact_form',

    // Badge
    API_BADGES_BY_ID: (id: string | number) => `/api/badges/${id}`,

    // Location
    API_GET_LOCATIONS: '/api/locations/',

    //Partner
    API_GET_PARTNERS: '/api/partners',

    // Stripe
    API_REQUEST_STRIPE_PAYMENT: '/api/payment/request_stripe_payment',
    API_REQUEST_STRIPE_PAYMENT_GUEST: '/api/payment/request_stripe_payment_guest',


    //API ORDER DATE GROUPS
    API_ORDER_DATE_GROUPS: '/api/order_date_groups/',

    //API ORDER DATE RULES
    API_ORDER_DATE_RULES: '/api/order_date_rules/',
}

export const PRODUCT_ROUTE_PATHS = [PATH_NAME.PRODUCT, PATH_NAME.PRODUCTS] as const;